import * as React from 'react';
import * as ConfigService from 'ts/config/ConfigService';
import { Colors, LinkText, Text } from '@origin-digital/style-guide';
import { isNative } from 'ts/services/native/native';
import { getLoginUrl } from 'ts/login/services/urlService';
import styled from 'styled-components';

const LogInNowSection: React.FC<{}> = () => {
  return (
    <LoginText data-id="login-text">
      Already have an account? Great! &nbsp;
      <LoginLink
        data-id="login-link"
        // we need a hash url for native
        // as the bootstrap urls wont work, as the authorize
        // call needs to be done natively to return back
        // into the app
        href={isNative() ? getLoginUrl() : ConfigService.getLoginBootstrapUrl()}
        title="Log in now"
        text="Log in now"
      />
    </LoginText>
  );
};

export { LogInNowSection };

const LoginText = styled(Text)`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.7;
  letter-spacing: normal;
  color: ${Colors.GREY};
  padding-top: 24px;
`;

const LoginLink = styled(LinkText)`
  color: ${Colors.RED};
  text-decoration: none;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.7;
  letter-spacing: normal;
`;
